import { render, staticRenderFns } from "./CampaignForm.vue?vue&type=template&id=58b140f4&scoped=true&"
import script from "./CampaignForm.vue?vue&type=script&lang=js&"
export * from "./CampaignForm.vue?vue&type=script&lang=js&"
import style0 from "./CampaignForm.vue?vue&type=style&index=0&id=58b140f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b140f4",
  null
  
)

export default component.exports